// extracted by mini-css-extract-plugin
module.exports = {"tag":"ProductTag_tag__1vw6b"};